import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TR from './../../Trans';
import Box from '@mui/material/Box';
import {
  useSearchParams,
} from "react-router-dom";
import TextField from '@mui/material/TextField';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import { Capacitor } from '@capacitor/core';
import ThemeToggleButton from '../items/ThemeToggleButton';
import { useLocalStorage } from '../../services/useLocalStorage';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Error from './../items/Error';
import muvikaAttrs from './../../attrs';
import Stack from '@mui/material/Stack';
import Message from './../items/Message';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import Waiting from './../items/Waiting';
import sessionStore from './../../stores/session';
import accountStore from './../../stores/account';
import messageStore from './../../stores/message';
import captchaStore from '../../stores/captcha';
import environmentStore from './../../stores/environment';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function Register() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const [queryParameters] = useSearchParams();

  const [, updateState] = useState();

  const sessionToken = sessionStore((state) => state.sessionToken);
  const captchaId = captchaStore((state) => state.captchaId);
  const captchaData = captchaStore((state) => state.captchaData);
  const createCaptcha = captchaStore((state) => state.createCaptcha);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const isSessionOpening = sessionStore((state) => state.isSessionOpening);
  const updateSession = sessionStore((state) => state.updateSession);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const openSession = sessionStore((state) => state.openSession);
  const createAccountPin = accountStore((state) => state.createAccountPin);
  const isAccountPinSet = accountStore((state) => state.isAccountPinSet);
  const verifyPin = accountStore((state) => state.verifyPin);
  const verificationCode = accountStore((state) => state.verificationCode);
  const clearAccountStore = accountStore((state) => state.clearAll);
  const isWaiting = accountStore((state) => state.isWaiting);
  const setError = messageStore((state) => state.setError);
  const logout = sessionStore((state) => state.logout);

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem(muvikaAttrs.service + "-session-language");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [captchaCode, setCaptchaCode] = useState('');
  const [isCaptchaTryingAgain, setIsCaptchaTryingAgain] = useState(false);

  useEffect(() => {
    if (language.length > 0) {
      handleLanguageChange(language);
    }
    if (isLoggedIn) {
      logout();
    }
    clearAccountStore();
    document.title = TR.ww_page_title;
  }, []);

  const handleLanguageChange = (language) => {
    let lowLang = language.toLowerCase();
    updateSession(sessionToken, lowLang);
    updateState({});
  };

  useEffect(() => {
    if (!isSessionOpen && !isSessionOpening) {
      openSession(language.length > 0 ? language.toLowerCase() : "english");
    }
  });

  useEffect(() => {
    if (isSessionOpen) {
      if (!captchaId && !captchaData) {
        createCaptcha(sessionToken);
      }
    }
  }, [sessionToken]);

  useEffect(() => {
    if (captchaData) {
      setCaptchaCode('');
      setIsCaptchaTryingAgain(true);
    }
  }, [captchaData]);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleKeyDownEmail = (event) => {
    if (event.key === 'Enter') {
      handleAccountPinCreation();
    }
  };

  const handleKeyDownVerifyPin = (event) => {
    if (event.key === 'Enter') {
      verifyPin(sessionToken, pin, email, "create_account");
    }
  };

  const handleAccountPinCreation = () => {
    if (validateEmail(email)) {
      if (captchaCode.length > 0) {
        let source = queryParameters.get("source");
        let license = queryParameters.get("license");
        createAccountPin(sessionToken, email, "create_account", captchaId, captchaCode, null, null, source, license);
      } else {
        setError(sessionToken, 0, TR.cm_invalid_captcha_code);
      }
    } else {
      setError(sessionToken, 0, TR.cm_invalid_email);
    }
  };

  const renderCaptcha = () => {
    if (captchaId && captchaData) {
      return <Box>
        <InputLabel>{TR.cm_enter_captcha_code}</InputLabel>
        <Stack direction="row" spacing={2}>
          <img src={captchaData} />
          <TextField
            id="muvika-register-captcha"
            margin="normal"
            size="small"
            required
            fullWidth
            value={captchaCode}
            autoFocus={isCaptchaTryingAgain}
            onChange={(e) => setCaptchaCode(e.target.value.toLowerCase())}
          />
        </Stack>
      </Box>;
    }
  };

  const renderAskEmailForm = () => {
    return <Box sx={{ width: "100%" }} onKeyDown={handleKeyDownEmail}>
      <Box sx={{ margin: 2 }}>
        <InputLabel>{TR.cm_email}</InputLabel>
        <TextField
          id="muvika-register-email"
          margin="normal"
          size="small"
          required
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value.toLowerCase())}
        />
        {renderCaptcha()}
      </Box>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button href="#/login" variant="text" color="secondary">{TR.cm_cancel}</Button>
        <Button variant="text" color="success" onClick={handleAccountPinCreation}>
          {TR.cm_register}
        </Button>
      </Stack>
    </Box>;
  };

  const renderWaitingOrEmail = () => {
    if (isWaiting) {
      return <Waiting />;
    } else {
      return renderAskEmailForm();
    }
  };

  const renderAskPinForm = () => {
    return <Box sx={{ width: "100%" }} o onKeyDown={handleKeyDownVerifyPin}>
      <Box sx={{ margin: 2 }}>
        <p>
          {TR.cm_account_creation_pin_sent}
        </p>
        <InputLabel>{TR.cm_pin}</InputLabel>
        <TextField
          autoFocus
          id="muvika-register-pin"
          margin="normal"
          type="text"
          size="small"
          required
          fullWidth
          autoComplete="off"
          defaultValue={pin}
          onChange={(e) => setPin(e.target.value)}
        />
      </Box>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button variant="text" color="secondary" onClick={() => {
          clearAccountStore();
          createCaptcha(sessionToken);
          setEmail("");
        }}>{TR.cm_cancel}</Button>
        <Button variant="text" color="success" onClick={() => verifyPin(sessionToken, pin, email, "create_account")}>
          {TR.cm_register}
        </Button>
      </Stack>
    </Box>;
  };

  const register = () => {
    if (verificationCode) {
      return <Navigate to={"/createaccount?verification_code=" + verificationCode} />;
    } else {
      if (!isAccountPinSet) {
        return renderWaitingOrEmail();
      } else {
        return renderAskPinForm();
      }
    }
  };

  const renderWelcome = () => {
    let source = queryParameters.get("source");
    if (source) {
      if (TR["cm_welcome_to_reg_" + source]) {
        return <p>
          {TR["cm_welcome_to_reg_" + source]}
        </p>;
      }
    }
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-svg" />;
    }
  };

  const renderIfSessionOpen = () => {
    if (isSessionOpen && !isLoggedIn) {
      return <ThemeProvider theme={darkTheme}>
        <Container component="main" className="muvika-entry-container" maxWidth="xs">
          <CssBaseline />
          <Error />
          <Message />
          <Box
            className="muvika-entry-box"
          >
            <p>
              <a href="#/">{renderLogo()}</a>
            </p>
            <Typography component="h1" variant="h5">
              {TR.cm_register}
            </Typography>
            {renderWelcome()}
            {register()}
            <ThemeToggleButton />
          </Box>
        </Container>
      </ThemeProvider >;
    } else if (isLoggedIn) {
      logout();
    }
  };

  const renderIfLoggedIn = () => {
    if (isSessionOpen && isLoggedIn) {
      return <Navigate to="/" />;
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <div>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      {renderOverflowStyle()}
      {renderIfSessionOpen()}
    </div>
  );
}

export default Register;
